var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfieOverlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 360,
    viewBox: "0 0 480 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240.5 17C310.144 17 367 89.7287 367 180C367 270.271 310.144 343 240.5 343C170.856 343 114 270.271 114 180C114 89.7287 170.856 17 240.5 17Z",
    stroke: "#DB9E2F",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M480 360H0V0H480V360ZM240.5 16C170.084 16 113 89.4253 113 180C113 270.575 170.084 344 240.5 344C310.916 344 368 270.575 368 180C368 89.4253 310.916 16 240.5 16Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfieOverlay);
export default __webpack_public_path__ + "static/media/selfie_overlay.f59eb91ce7aab6cd70c5da3248626657.svg";
export { ForwardRef as ReactComponent };